import { Empresa, Sede } from './usuario.model';
import { TipoControl, ValidacionesColumnaMaestra } from './formulario-dinamico.model';
/**
 * Modelo de las tablas maestras de las formas dinamicas
 *
 * @export
 * @class TablaMaestra
 */
export class TablaMaestra {
  id?: number;
  nombre: string;
  descripcion: string;
  alias: string;
  usuarios: boolean;
}

/**
 * Modelo de la informacion de las tablas maestras de las formas dinamicas
 *
 * @export
 * @class InformacionTablaMaestra
 */
export class InformacionTablaMaestra {
  id?: number;
  nombre?: string;
  descripcion: string;
  estructura: Array<ColumnaMaestra>;
  valores?: Array<Valores>;
}

/**
 * Columna de la estructura de una maestra
 *
 * @export
 * @class ColumnaMaestra
 */
export class ColumnaMaestra {
  id?: number;
  nombre: string;
  placeholder: string;
  espacio: number;
  validaciones: ValidacionesColumnaMaestra;
  orden: number;
  requerido: boolean;
  unico: boolean;
  propiedades: any;
  tipo_campo: TipoControl | number;
  maestra_dependencia: number | MaestraDependencia;
  alias: string;
}

/**
 * Maestra dependencia de una columna
 *
 * @export
 * @class MaestraDependencia
 */
export class MaestraDependencia {
  id: number;
  nombre: string;
  estructura: Array<ColumnaMaestra>;
  valores?: Array<Valores>;
}

/**
 * Modelo de valores que componen la consulta de la dependencia de una columna
 *
 * @export
 * @class Valores
 */
export class Valores {
  id: number;
  datos: any;
  user_login?: LoginDefault;
}

/**
 * Modelo complementario de los valores de las maestras
 * Este modelo se utiliza para la maestra de usuarios
 *
 * @export
 * @class LoginDefault
 */
export class LoginDefault {
  id?: number;
  is_active?: boolean;
  password?: string;
  username?: string;
}

/**
 * Modleo de la consulta d eun login en especifico
 *
 * @export
 * @class Login
 * @extends {LoginDefault}
 */
export class Login extends LoginDefault {
  groups: Array<Grupos>;
  empresa: Empresa;
  sede: Sede;
  cargo: CargoUsuario;
}

/**
 * Modelo del la informacion que se debe enviar para registrar o modificar un login del sistema
 *
 * @export
 * @class LoginSaved
 * @extends {LoginDefault}
 */
export class LoginSaved extends LoginDefault {
  user_groups?: Array<number>;
  sede?: number;
  cargo: number;
}

/**
 * Modelo complementario de Login
 *
 * @export
 * @class Grupos
 */
export class Grupos {
  id: number;
  nombre: string;
}

/**
 * Modelo de los valores de las tablas maestras
 * endpoint: masterTableSpecificInformation
 * @export
 * @class ValoresEspecificos
 */
export class ValoresEspecificos {
  id: number;
  valores: any;
}

/**
 * Modelo de la estructrura para las consultas de columnas en especifico de la maestra
 *
 * @export
 * @class EstructuraEspecifica
 */
export class EstructuraEspecifica {
  maestra: string;
  columnas?: Array<string>;
  dependencia?: Array<EstructuraEspecifica>;
}

/**
 * Modelo de los filtros de las columnas o campos de maestras y formas dinamicas
 *
 * @export
 * @class FiltroTableMasterGeneral
 */
export class FiltroTableMasterGeneral {
  maestra?: string;
  columna: string;
  valor: string;
  operador: string;
  condicional?: string;
}

/**
 * Modelo complementario de Login
 * Informacion del cargo
 *
 * @export
 * @class Grupos
 */
export class CargoUsuario {
  id: number;
  nombre: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/tabla-maestra.model.ts